export enum ESymbolAnimations {
    DEFAULT = 'SYMBOL_DEFAULT',
    BLUR = 'SYMBOL_BLUR',
    SHORT = 'SYMBOL_SHORT_ANIM',
    NOTWIN = 'SYMBOL_NOTWIN',
    WIN = 'SYMBOL_WIN',
    INTERCHANGEABLE_SYMBOL_WIN = 'INTERCHANGEABLE_SYMBOL_WIN',
    WIN_NOT_ON_LINE = 'SYMBOL_WIN_NOT_ON_LINE',
    SCATTER = 'SYMBOL_SCATTER_ANIM',
    WILD = 'WILD_ANIM',
    SYMBOL_SPECIAL_GAMES_WIN = 'SYMBOL_SPECIAL_GAMES_WIN',
    SYMBOL_LOCK = 'SYMBOL_LOCK',
    SYMBOL_LOCKED = 'SYMBOL_LOCKED',
    SYMBOL_UNLOCK = 'SYMBOL_UNLOCK'
}
